// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  background: var(--footerBg);
}
footer .content-wrapper {
  margin: 0 auto;
}
footer .sidebar-close {
  margin-left: 66px;
}
footer .custom-spacer {
  max-width: 1100px;
  padding: 1.75rem !important;
}
@media screen and (max-width: 767.98px) {
  footer .custom-spacer {
    padding: 0.75rem 0 0.75rem !important;
  }
}
footer .footer-top {
  padding: 0;
}
@media screen and (max-width: 767.98px) {
  footer .footer-top {
    padding: 2rem 1rem;
  }
}
footer .footer-top p {
  font-size: 0.75rem;
  color: var(--authTabBtnText);
  font-weight: 500;
  line-height: 1.063rem;
}
footer .footer-top .footer-contact-top {
  color: var(--lightkGray);
}
footer .footer-top .footer-contact-top h6 {
  font-weight: 300;
  font-size: 13px;
}
footer .footer-top .footer-linking {
  flex-direction: column;
  padding: 0;
}
footer .footer-top .footer-linking a {
  display: block;
  padding: 0.313rem 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--authTabBtnText);
}
footer .footer-top .footer-linking a:hover {
  color: var(--headingLink);
}
footer .footer-top .footer-linking h4 {
  color: var(--white);
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: 500;
  padding-bottom: 0.2rem;
}
@media screen and (min-width: 768px) {
  footer .footer-top .footer-about {
    max-width: 301px;
  }
}
footer .footer-top .footer-about .footer-logo {
  margin-bottom: 0.625rem;
}
footer .footer-top .footer-about .footer-logo svg {
  width: 204px;
}
footer .footer-bottom {
  padding: 2rem 0rem;
  background: var(--footerBg);
}
@media screen and (max-width: 767.98px) {
  footer .footer-bottom {
    text-align: center;
    padding: 1rem;
  }
}
footer .footer-bottom img {
  margin-right: 2rem;
}
@media screen and (max-width: 767.98px) {
  footer .footer-bottom img {
    margin-right: 0;
    margin-bottom: 1rem;
  }
}
footer .footer-bottom p {
  font-size: 0.75rem;
  color: var(--authTabBtnText);
  font-weight: 500;
  line-height: 1.063rem;
}
@media screen and (max-width: 767.98px) {
  footer .footer-bottom p {
    line-height: 1.5rem;
    margin: 0;
  }
}
footer .footer-bottom p a {
  color: var(--white);
  padding: 0 0.2rem;
}
footer .language-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
footer .language-wrap .copyright-section p {
  color: var(--authTabBtnText);
  font-size: 0.688rem;
  font-weight: 500;
}
@media screen and (max-width: 767.98px) {
  footer .language-wrap .copyright-section p {
    padding-bottom: 0.313rem;
  }
}
footer .language-wrap .btn-secondary {
  width: auto;
  background: var(--selectBg);
  border-color: var(--footerBorder);
  color: var(--authTabBtnText);
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  border-radius: 0.25rem;
  min-height: 32px;
}
footer .language-wrap .btn-secondary img {
  margin-right: 0.313rem;
  width: 1rem;
  height: 1rem;
}
footer .footer-bottom-linking {
  padding: 1.2rem;
}
footer .footer-bottom-linking p {
  font-size: 0.75rem;
  color: var(--authTabBtnText);
  font-weight: 500;
  position: relative;
  padding: 0 0.625rem;
  margin: 0;
}
@media screen and (max-width: 767.98px) {
  footer .footer-bottom-linking p {
    text-align: center;
  }
}
footer .footer-bottom-linking p:before {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 1px;
  background: var(--white);
  content: "";
}
@media screen and (max-width: 767.98px) {
  footer .footer-bottom-linking p:before {
    display: none;
  }
}
footer .footer-bottom-linking p:last-child:before {
  display: none;
}
footer .footer-bottom-linking p a {
  color: var(--white);
  font-weight: 500;
  padding: 0 0.3rem;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Footer/footer.scss"],"names":[],"mappings":"AAAA;EAME,2BAAA;AAJF;AADE;EACE,cAAA;AAGJ;AAGE;EACE,iBAAA;AADJ;AAIE;EACE,iBAAA;EACA,2BAAA;AAFJ;AAII;EACE;IACE,qCAAA;EAFN;AACF;AAME;EACE,UAAA;AAJJ;AAMI;EAHF;IAII,kBAAA;EAHJ;AACF;AAKI;EACE,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,qBAAA;AAHN;AAMI;EACE,wBAAA;AAJN;AAMM;EACE,gBAAA;EACA,eAAA;AAJR;AAQI;EACE,sBAAA;EACA,UAAA;AANN;AAQM;EACE,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;AANR;AAQQ;EACE,yBAAA;AANV;AAUM;EACE,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AARR;AAaM;EADF;IAEI,gBAAA;EAVN;AACF;AAYM;EACE,uBAAA;AAVR;AAYQ;EACE,YAAA;AAVV;AAgBE;EACE,kBAAA;EACA,2BAAA;AAdJ;AAgBI;EAJF;IAKI,kBAAA;IACA,aAAA;EAbJ;AACF;AAeI;EACE,kBAAA;AAbN;AAeM;EAHF;IAII,eAAA;IACA,mBAAA;EAZN;AACF;AAeI;EACE,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,qBAAA;AAbN;AAeM;EANF;IAOI,mBAAA;IACA,SAAA;EAZN;AACF;AAcM;EACE,mBAAA;EACA,iBAAA;AAZR;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAfJ;AAkBM;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;AAhBR;AAkBQ;EALF;IAMI,wBAAA;EAfR;AACF;AAmBI;EACE,WAAA;EACA,2BAAA;EACA,iCAAA;EACA,4BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AAjBN;AAmBM;EACE,sBAAA;EACA,WAAA;EACA,YAAA;AAjBR;AAsBE;EACE,eAAA;AApBJ;AAsBI;EACE,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;AApBN;AAsBM;EARF;IASI,kBAAA;EAnBN;AACF;AAqBM;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;AAnBR;AAqBQ;EATF;IAUI,aAAA;EAlBR;AACF;AAsBQ;EACE,aAAA;AApBV;AAwBM;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAtBR","sourcesContent":["footer {\n  .content-wrapper {\n    margin: 0 auto;\n  }\n\n  // margin-left: 230px;\n  background: var(--footerBg);\n\n  .sidebar-close {\n    margin-left: 66px;\n  }\n\n  & .custom-spacer {\n    max-width: 1100px;\n    padding: 1.75rem !important;\n\n    @media screen and (max-width: 767.98px) {\n      & {\n        padding: 0.75rem 0 0.75rem !important;\n      }\n    }\n  }\n\n  .footer-top {\n    padding: 0;\n\n    @media screen and (max-width: 767.98px) {\n      padding: 2rem 1rem;\n    }\n\n    p {\n      font-size: 0.75rem;\n      color: var(--authTabBtnText);\n      font-weight: 500;\n      line-height: 1.063rem;\n    }\n\n    .footer-contact-top {\n      color: var(--lightkGray);\n\n      h6 {\n        font-weight: 300;\n        font-size: 13px;\n      }\n    }\n\n    .footer-linking {\n      flex-direction: column;\n      padding: 0;\n\n      a {\n        display: block;\n        padding: 0.313rem 0;\n        font-size: 0.875rem;\n        font-weight: 500;\n        color: var(--authTabBtnText);\n\n        &:hover {\n          color: var(--headingLink);\n        }\n      }\n\n      h4 {\n        color: var(--white);\n        text-transform: uppercase;\n        font-size: 1rem;\n        font-weight: 500;\n        padding-bottom: 0.2rem;\n      }\n    }\n\n    .footer-about {\n      @media screen and (min-width: 768px) {\n        max-width: 301px;\n      }\n\n      .footer-logo {\n        margin-bottom: 0.625rem;\n\n        svg {\n          width: 204px;\n        }\n      }\n    }\n  }\n\n  .footer-bottom {\n    padding: 2rem 0rem;\n    background: var(--footerBg);\n\n    @media screen and (max-width: 767.98px) {\n      text-align: center;\n      padding: 1rem;\n    }\n\n    img {\n      margin-right: 2rem;\n\n      @media screen and (max-width: 767.98px) {\n        margin-right: 0;\n        margin-bottom: 1rem;\n      }\n    }\n\n    p {\n      font-size: 0.75rem;\n      color: var(--authTabBtnText);\n      font-weight: 500;\n      line-height: 1.063rem;\n\n      @media screen and (max-width: 767.98px) {\n        line-height: 1.5rem;\n        margin: 0;\n      }\n\n      a {\n        color: var(--white);\n        padding: 0 0.2rem;\n      }\n    }\n  }\n\n  .language-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .copyright-section {\n      p {\n        color: var(--authTabBtnText);\n        font-size: 0.688rem;\n        font-weight: 500;\n\n        @media screen and (max-width: 767.98px) {\n          padding-bottom: 0.313rem;\n        }\n      }\n    }\n\n    .btn-secondary {\n      width: auto;\n      background: var(--selectBg);\n      border-color: var(--footerBorder);\n      color: var(--authTabBtnText);\n      font-weight: 400;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 0.75rem;\n      border-radius: 0.25rem;\n      min-height: 32px;\n\n      img {\n        margin-right: 0.313rem;\n        width: 1rem;\n        height: 1rem;\n      }\n    }\n  }\n\n  .footer-bottom-linking {\n    padding: 1.2rem;\n\n    p {\n      font-size: 0.75rem;\n      color: var(--authTabBtnText);\n      font-weight: 500;\n      position: relative;\n      padding: 0 0.625rem;\n      margin: 0;\n\n      @media screen and (max-width: 767.98px) {\n        text-align: center;\n      }\n\n      &:before {\n        position: absolute;\n        right: 0;\n        top: 0;\n        height: 100%;\n        width: 1px;\n        background: var(--white);\n        content: \"\";\n\n        @media screen and (max-width: 767.98px) {\n          display: none;\n        }\n      }\n\n      &:last-child {\n        &:before {\n          display: none;\n        }\n      }\n\n      a {\n        color: var(--white);\n        font-weight: 500;\n        padding: 0 0.3rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
